import { Box } from 'components/layouts/primitives/Box/Box';
import styled from 'styled-components';
import { colourPalette, cssScreens, padding } from 'styles/styles';

export const HeyYabbleCountStepSummaryStyle = {
  Container: styled(Box)`
    width: 30%;
    background: ${colourPalette.neutral100};
    margin: 10px 0 40px 20px;
    position: sticky;
    top: 0;
    @media screen and (max-width: ${cssScreens.tablet}) {
      width: 100%;
      margin: 0;
      margin-top: -10px;
      position: relative;
      top: auto;
    }
  `,
  List: styled.ul`
    margin: 0;
    padding-left: ${padding.paddingXL};

    & li::marker {
      color: ${colourPalette.neutral400};
    }
  `,
};
